import { PreloadedState } from 'redux'
import { CombinedState } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'
import { Config } from 'modules/config/state/config-types'
import { makeOrderDonorCoveredFeesInitialState } from '../dcf/order-donor-covered-fees-utils'
import { makeOrderFrequencyInitialState } from '../frequency/order-frequency-utils'
import { makeOrderRecurringEndDateInitialState } from '../recurring-end-date/order-recurring-end-date-utils'
import { URLParams } from 'modules/url-params/state/app-url-params-types'
import { getOrderAmountInitialState } from '../amount/order-amount-utils'
import { makeOrderCurrencyInitialState } from '../currency/order-currency-utils'
import { makeOrderAddressInitialState } from '../address/address-utils'
import { makeOrderContactInitialState } from '../contact/contact-utils'
import { makeOrderCommentInitialState } from '../comment/order-comment-utils'
import { makeOrderDesignationInitialState } from '../designation/order-designation-utils'
import { makeOrderDoubleTheDonationInitialState } from '../double-the-donation/order-double-the-donation-utils'
import { makeOrderCustomAnswersInitialState } from '../custom-answers/custom-answers-utils'

export const makeOrderInitialState = (
  config: Config,
  urlParams: URLParams,
): PreloadedState<CombinedState<RootState['order']>> => {
  return {
    dcf: makeOrderDonorCoveredFeesInitialState(config),
    frequency: makeOrderFrequencyInitialState(config, urlParams),
    recurringEndDate: makeOrderRecurringEndDateInitialState(urlParams),
    amount: getOrderAmountInitialState(config, urlParams),
    currency: makeOrderCurrencyInitialState(config, urlParams),
    address: makeOrderAddressInitialState(urlParams),
    contact: makeOrderContactInitialState(config, urlParams),
    customAnswers: makeOrderCustomAnswersInitialState(config),
    comment: makeOrderCommentInitialState(),
    designation: makeOrderDesignationInitialState(config, urlParams),
    doubleTheDonation: makeOrderDoubleTheDonationInitialState(),
  }
}
